import { EditorState, Plugin, PluginKey } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

import { IAnnotationDecoration } from "@/view/TiptapArticleBody/extensions/TextHighlighting";
import { isTextClicked, setUpDecorations } from "./utils";

interface HighlightingPluginProps {
  annotations: (state: EditorState) => IAnnotationDecoration[];
  onClick?: (state: EditorState) => void;
}

const HighlightingPlugin = ({
  annotations: getAnnotations,
  onClick,
}: HighlightingPluginProps) => {
  return new Plugin({
    key: new PluginKey("highlightPlugin"),
    props: {
      decorations(state) {
        const annotations = getAnnotations(state);

        if (!annotations.length) return DecorationSet.empty;

        const doc = state.doc;

        let decorations: Decoration[] = [];

        for (const annotation of annotations) {
          const newDecorations = setUpDecorations(doc, annotation);

          decorations = [...decorations, ...newDecorations];
        }

        return DecorationSet.create(doc, decorations);
      },
      handleClick: (view, __pos, event) => {
        const eventTarget = event.target as HTMLElement | null;

        if (eventTarget instanceof HTMLElement) {
          if (onClick && isTextClicked(eventTarget)) {
            onClick(view.state);
          }
        }
      },
    },
  });
};

export default HighlightingPlugin;
